import Badge from '@axa-japan/design-system-react/Badge';
import Text from '@axa-japan/design-system-react/Text';
import { RefObject } from 'react';
import { ImageQualityCheckResult } from '../../utils/imageQualityCheck/imageQualityCheck';
import FloatingPopup from '../common/FloatingPopup/FloatingPopup';

type QualityCheckPopupProps = {
  open: boolean;
  onClose: () => void;
  containerRef: RefObject<HTMLElement>;
  isChecking: boolean;
  result: ImageQualityCheckResult | undefined;
};

const QualityCheckPopup = ({ open, onClose, containerRef, isChecking, result }: QualityCheckPopupProps) => {
  return (
    <FloatingPopup open={open && (isChecking || Boolean(result))} title="画像品質チェック" onClose={onClose} containerRef={containerRef}>
      {isChecking && <Text>画像品質をチェック中...</Text>}
      {!isChecking && result && (
        <>
          <Text size="lg" weight="bold">
            画像品質チェック結果:
            {!result.overall ? <Badge variant="warning" text="確認" className="!ml-2" /> : <Badge variant="success" text="OK" className="!ml-2" />}
          </Text>
          {!result.overall && (
            <ul className="list-disc pl-4 mt-2">
              {!result.blur && <li className="text-statusDanger whitespace-nowrap">画像がぼやけていませんか？</li>}
              {!result.shadow && <li className="text-statusDanger whitespace-nowrap">画像に影が入っていませんか？</li>}
              {!result.darkness && <li className="text-statusDanger whitespace-nowrap">画像の明るさに問題はありませんか？</li>}
              {!result.boundary && <li className="text-statusDanger whitespace-nowrap">書類の全体が読み取れる大きさで写っていますか？</li>}
              {!result.background && <li className="text-statusDanger whitespace-nowrap">書類以外のものが写り込んでいませんか？</li>}
            </ul>
          )}
        </>
      )}
    </FloatingPopup>
  );
};

export default QualityCheckPopup;
